import Config from './labels.router';
import options from './labels.component';
import LabelDetails from './label-details';

const Component = {
    selector: 'dtLabelsView',
    options
};

export {
    Config,
    Component,
    LabelDetails
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/index.js